export const getOccupationalMedicineStateEndpoint = (appointmentId: string) =>
    `/api/appointments/${appointmentId}/occupational-medicine-state`;

export const getOccupationalMedicineDataEndpoint = (appointmentId: string) =>
    `/api/appointments/${appointmentId}/occupational-medicine-data`;

export const getOccupationalMedicineDocumentPreviewEndpoint = (id: number) =>
    `/api/OccupationalMedicine/${id}/preview`;

export const getAppointmentQuestionnaireEntryEndpoint = (appointmentId: string) =>
    `/api/appointments/${appointmentId}/questionnaire-entry`;

export const getConfirmDraftPrescriptionFilledEndpoint = (appointmentId: number) =>
    `/api/appointments/${appointmentId}/confirm-draft-prescription-filled`;

export const getSendQuestionEndpoint = (appointmentId: number) =>
    `/api/appointments/${appointmentId}/question`;